import api from './apiClient';
import config from '../../../config';

export interface CareerOverview {
  careerName: string;
  slug: string;
  group: string;
  overview: string;
  traits: string[];
  drawbacks: string[];
  dayToDay: string[];
  usefulVideos: string[];
  requirements: {
    academic: string[];
    academicNotes: string[];
    trainingNotes: string[];
    other: string[];
  };
  routes: {
    academic: string[];
    vocation: string[];
    workBased_training: string[];
  };
  resources: {
    keyLinks: string[];
    professionalBodies: string[];
    generalInformation: string[];
    caseStudies: string[];
    jobs: string[];
  };
}

function unwrap<T>(res: { data: { data: T } }): T {
  return res.data.data;
}

export const careerOverviewApi = {
  async getByGroup(group: string, limit = 50): Promise<CareerOverview[]> {
    if (config.appMode === 'prototype') return [];
    try {
      const res = await api.get('/career-overviews', { params: { group, limit } });
      return unwrap<{ overviews: CareerOverview[] }>(res).overviews;
    } catch {
      return [];
    }
  },

  async getBySlug(slug: string): Promise<CareerOverview | null> {
    if (config.appMode === 'prototype') return null;
    try {
      const res = await api.get(`/career-overviews/${slug}`);
      return unwrap<{ overview: CareerOverview }>(res).overview;
    } catch {
      return null;
    }
  },

  async getByName(careerName: string): Promise<CareerOverview | null> {
    if (config.appMode === 'prototype') return null;
    try {
      const res = await api.get(`/career-overviews/by-name/${encodeURIComponent(careerName)}`);
      return unwrap<{ overview: CareerOverview }>(res).overview;
    } catch {
      return null;
    }
  },
};
